export const SEND_ORDER = 'app/core/reducers/cart/SEND_ORDER';
